// libs
import { useSelector } from 'react-redux';

// interfaces
import { IRootState } from 'src/reducers/interface';

export const useSelectCategories = () => useSelector(({ categories }: IRootState) => categories);
